var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.63415 27C1.90976 27 1.28942 26.7426 0.773124 26.2278C0.256831 25.713 -0.000875813 25.0934 2.23612e-06 24.3691V5.9525C2.23612e-06 5.22899 0.258149 4.6094 0.774441 4.09374C1.29073 3.57808 1.91064 3.32068 2.63415 3.32156H14.389L5.26829 12.4312V21.7381H14.5866L23.7073 12.5956V24.3691C23.7073 25.0926 23.4492 25.7122 22.9329 26.2278C22.4166 26.7435 21.7967 27.0009 21.0732 27H2.63415ZM7.90244 19.1072V13.5164L17.3524 4.07795L22.9829 9.60292L13.5 19.1072H7.90244ZM24.8598 7.72838L19.2293 2.20341L20.6451 0.789281C21.172 0.263094 21.8033 0 22.5391 0C23.2749 0 23.8948 0.263094 24.3988 0.789281L26.2427 2.66382C26.7476 3.16809 27 3.78197 27 4.50548C27 5.22899 26.7476 5.84287 26.2427 6.34714L24.8598 7.72838Z",
    fill: "#2B2B2B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.f7ffdd07a70dc78d3228940c9201e8ad.svg";
export { ForwardRef as ReactComponent };